<template>
  <el-form ref="form" :model="curInput" label-width="100px" v-loading="loading">
    <el-form-item label="记录类型">
      <el-radio-group v-model="curInput.user_info.default_type">
        <el-radio :label="10">创建人</el-radio>
        <el-radio :label="20">修改人</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="默认值">
      <el-select v-model="curInput.user_info.field" placeholder="请选择">
        <el-option
          v-for="item in userInfos"
          :key="item.value"
          :label="item.name"
          :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
  import http from '../../../assets/js/http'

  export default {
    props: ['curInput'],
    data() {
      return {
        userInfos: []
      }
    },
    created() {
      this.apiGet('cms/deals/fields/1').then((res) => {
        if (res.code == 200) {
          _(res.data).forEach((user) => {
            this.userInfos.push({
              name: user.title,
              value: user.field
            })
          })
        }
      })
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// userInfoConfig.vue?947bb840